<template>
  <DropdownInput
    :disabled="disabled"
    :items="items"
    :modelValue="value"
    @update:modelValue="handleChange"
    name="dates"
  />
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

import DropdownInput from "@/Tailwind/Components/Input/DropdownInput";

const emit = defineEmits(["change"]);
const props = defineProps({
  month: Number,
  disabled: {
    type: Boolean,
    default: false,
  },
  value: Number,
});

const items = computed(() => {
  let items = [];

  if (props.month === undefined || props.month === null) {
    items = Array.from({ length: 31 }, (_, i) => i + 1);
  } else {
    const n = new Date(new Date().getFullYear(), props.month, 0).getDate();
    items = Array.from({ length: n }, (_, i) => i + 1);
  }

  return items.map((item) => ({ label: item, value: item }));
});

function handleChange(v) {
  emit("change", Number(v));
}
</script>
